import { Routes } from '@angular/router'
import { AuthGuard } from './guards/auth.guard'

export const routes: Routes = [
  {
    path: '',
    // redirectTo: '/user/tab/wanted/preselect-for-main',
    redirectTo: '/user/tab/fabric',
    pathMatch: 'full',
  },
  {
    path: 'user/bizprofile',
    loadChildren: () => import('./bizprofile/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/tab',
    loadChildren: () => import('./tabs/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/setting',
    loadChildren: () => import('./setting/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  // for search
  {
    path: 'user/fabric',
    loadChildren: () => import('./fabric/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/store',
    loadChildren: () => import('./store/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/search',
    loadChildren: () => import('./search/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/inquiry',
    loadChildren: () => import('./inquiry/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/user-destination',
    loadChildren: () => import('./user-destination/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  // for wanted
  {
    path: 'user/wanted',
    loadChildren: () => import('./wanted/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  // for articles
  {
    path: 'user/comm',
    loadChildren: () => import('./comm/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  // for modal
  {
    path: 'user/static',
    loadChildren: () => import('./static/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/auth',
    loadChildren: () => import('./auth/routes').then(m => m.routes),
  },
  // for updating
  {
    path: 'updating',
    loadChildren: () => import('./updating/routes').then(m => m.routes),
  },
  // for event
  {
    path: 'user/event',
    loadChildren: () => import('./event/routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
]
